import { Action } from 'redux';
import { OrderedMap } from 'immutable';

import {
    GET_DISCUSSIONS_REQUEST,
    GET_DISCUSSIONS_RESPONSE,
    GET_DISCUSSIONS_ERROR,

    GET_MORE_DISCUSSIONS_REQUEST,
    GET_MORE_DISCUSSIONS_RESPONSE,
    GET_MORE_DISCUSSIONS_ERROR,

    GET_DISCUSSION_REQUEST,
    GET_DISCUSSION_RESPONSE,
    GET_DISCUSSION_ERROR,

    GET_MESSAGES_REQUEST,
    GET_MESSAGES_RESPONSE,
    GET_MESSAGES_ERROR,

    CREATE_DISCUSSION_REQUEST,
    CREATE_DISCUSSION_RESPONSE,
    CREATE_DISCUSSION_ERROR,

    MAKE_READ_DISCUSSION_REQUEST,
    MAKE_READ_DISCUSSION_RESPONSE,
    MAKE_READ_DISCUSSION_ERROR,

    SEND_MESSAGES_REQUEST,
    SEND_MESSAGES_RESPONSE,
    SEND_MESSAGES_ERROR,

    GET_MORE_MESSAGES_REQUEST,
    GET_MORE_MESSAGES_RESPONSE,
    GET_MORE_MESSAGES_ERROR,

    SET_DISCUSSION,
} from '../../actions/Accounting/discussion';

import { Discussion, Message } from '../../models/Accounting/Discussion';

export interface AccountingDiscussionState {
    discussions: OrderedMap<number, Discussion>;
    loadingDiscussions: boolean;
    errorDiscussions: any;

    discussion: Discussion;
    newDiscussion: Discussion;
    pageDiscussions: number;

    loadingCreateDiscussions: boolean;
    errorCreateDiscussions: any;

    loadingReadDiscussions: boolean;
    errorReadDiscussions: any;

    messages: OrderedMap<number, Message>;
    loadingMessages: boolean;
    errorMessages: any;
    pageMessages: number;

    message: Message;
    loadingSendMessage: boolean;
    errorSendMessage: any;
}

const initialState: AccountingDiscussionState = {
    discussions: OrderedMap<number, Discussion>(),
    loadingDiscussions: false,
    errorDiscussions: null,

    discussion: {} as Discussion,
    newDiscussion: {} as Discussion,
    pageDiscussions: 1,

    loadingCreateDiscussions: false,
    errorCreateDiscussions: null,

    loadingReadDiscussions: false,
    errorReadDiscussions: null,

    messages: OrderedMap<number, Message>(),
    loadingMessages: false,
    errorMessages: null,
    pageMessages: 1,

    message: {} as Message,
    loadingSendMessage: false,
    errorSendMessage: null
};

export function accountingDiscussionState(state: AccountingDiscussionState = initialState, action: Action) {
    switch (action.type) {
        case GET_DISCUSSIONS_REQUEST: {
            return {
                ...state,
                discussions: initialState.discussions,
                loadingDiscussions: true,
                errorDiscussions: initialState.errorDiscussions,
            };
        }
        case GET_DISCUSSIONS_RESPONSE: {
            const result: Discussion[] = (action as any).response.result;
            const discussions = result.reduce((prev, cur) => prev.set(cur.id, cur), initialState.discussions);
            const pageDiscussions = (action as any).response.pagination.next_page;
            return {
                ...state,
                loadingDiscussions: false,
                discussions,
                pageDiscussions,
            };
        }
        case GET_DISCUSSIONS_ERROR: {
            const errorDiscussions = (action as any).error;
            return {
                ...state,
                loadingDiscussions: false,
                errorDiscussions,
            };
        }

        case GET_MORE_DISCUSSIONS_REQUEST: {
            return {
                ...state,
                errorDiscussions: initialState.errorDiscussions
            };
        }
        case GET_MORE_DISCUSSIONS_RESPONSE: {
            const result: Array<Discussion> = (action as any).response.result;
            const discussions = result.reduce((prev, cur) => prev.set(cur.id, cur), state.discussions);
            const pageDiscussions = (action as any).response.pagination.next_page;
            return {
                ...state,
                discussions,
                pageDiscussions
            };
        }
        case GET_MORE_DISCUSSIONS_ERROR: {
            const errorDiscussions = (action as any).error;
            return {
                ...state,
                errorDiscussions
            };
        }

        case GET_DISCUSSION_REQUEST: {
            return {
                ...state,
                discussion: initialState.discussion,
                loadingDiscussions: true,
                errorDiscussions: initialState.errorDiscussions,
            };
        }
        case GET_DISCUSSION_RESPONSE: {
            const discussion: Discussion = (action as any).response.result;
            return {
                ...state,
                loadingDiscussions: false,
                discussion,
            };
        }
        case GET_DISCUSSION_ERROR: {
            const errorDiscussions = (action as any).error;
            return {
                ...state,
                loadingDiscussions: false,
                errorDiscussions,
            };
        }

        case CREATE_DISCUSSION_REQUEST: {
            return {
                ...state,
                newDiscussion: initialState.newDiscussion,
                loadingCreateDiscussions: true,
                errorCreateDiscussions: initialState.errorCreateDiscussions,
            };
        }
        case CREATE_DISCUSSION_RESPONSE: {
            const newDiscussion: Discussion = (action as any).response.result;
            const discussions = state.discussions.set(newDiscussion.id, newDiscussion);
            return {
                ...state,
                discussions,
                newDiscussion,
                loadingCreateDiscussions: false,
            };
        }
        case CREATE_DISCUSSION_ERROR: {
            const errorCreateDiscussions = (action as any).error;
            return {
                ...state,
                loadingCreateDiscussions: false,
                errorCreateDiscussions,
            };
        }

        case MAKE_READ_DISCUSSION_REQUEST: {
            return {
                ...state,
                loadingReadDiscussions: true,
                errorReadDiscussions: initialState.errorReadDiscussions,
            };
        }
        case MAKE_READ_DISCUSSION_RESPONSE: {
            return {
                ...state,
                loadingReadDiscussions: false,
            };
        }
        case MAKE_READ_DISCUSSION_ERROR: {
            const errorReadDiscussions = (action as any).error;
            return {
                ...state,
                loadingReadDiscussions: false,
                errorReadDiscussions,
            };
        }

        case SET_DISCUSSION: {
            const discussion = (action as any).discussion;
            return {
                ...state,
                discussion,
            };
        }

        case GET_MESSAGES_REQUEST: {
            return {
                ...state,
                loadingMessages: true,
                errorMessages: initialState.errorMessages,
                messages: initialState.messages,
            };
        }
        case GET_MESSAGES_RESPONSE: {
            const result: Message[] = (action as any).response.result;
            const messages = result.reduce((prev, cur) => prev.set(cur.id, cur), initialState.messages);
            const pageMessages = (action as any).response.pagination.next_page;
            return {
                ...state,
                loadingMessages: false,
                messages,
                pageMessages,
            };
        }
        case GET_MESSAGES_ERROR: {
            const errorMessages = (action as any).error;
            return {
                ...state,
                loadingMessages: false,
                errorMessages
            };
        }

        case SEND_MESSAGES_REQUEST: {
            return {
                ...state,
                loadingSendMessage: true,
                errorSendMessage: initialState.errorSendMessage,
                message: initialState.message,
            };
        }
        case SEND_MESSAGES_RESPONSE: {
            const message: Message = (action as any).response.result;
            let messages = initialState.messages;
            messages = messages.set(message.id, message);
            messages = state.messages.valueSeq().toArray().reduce((prev, cur) => {
                return prev.set(cur.id, cur);
            }, messages);
            return {
                ...state,
                loadingSendMessage: false,
                message,
                messages,
            };
        }
        case SEND_MESSAGES_ERROR: {
            const errorSendMessage = (action as any).error;
            return {
                ...state,
                loadingSendMessage: false,
                errorSendMessage,
            };
        }

        case GET_MORE_MESSAGES_REQUEST: {
            return {
                ...state,
                errorMessages: initialState.errorMessages
            };
        }
        case GET_MORE_MESSAGES_RESPONSE: {
            const result: Array<Message> = (action as any).response.result;
            const messages = result.reduce((prev, cur) => prev.set(cur.id, cur), state.messages);
            const pageMessages = (action as any).response.pagination.next_page;
            return {
                ...state,
                messages,
                pageMessages
            };
        }
        case GET_MORE_MESSAGES_ERROR: {
            const errorMessages = (action as any).error;
            return {
                ...state,
                errorMessages
            };
        }
        default: {
            return state;
        }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/Accounting/discussion.ts